import { Pipe, PipeTransform } from '@angular/core';
import { MemberQuery } from '@fgb/core';
import { buildContentAssetUrl } from '../utils/content-asset-url.util';

@Pipe({ name: 'cardTypeImage' })
export class CardTypeImagePipe implements PipeTransform {
  constructor(private memberQuery: MemberQuery) { }

  transform(value: any) {
    const cardLogo = this._getCardLogoByType(value);
    return buildContentAssetUrl(this.memberQuery, `payment-icons/${cardLogo}.svg`);
  }

  private _getCardLogoByType(type: number): string {
    switch(type){
      case 1:
        return '_Mastercard';
      case 2:
        return '_AMEX';
      case 3:
        return '_Visa-modified';
      case 4:
        return '_Discover';
      case 5:
        return '_JCB';
      case 7:
        return '_DinnersClub';
      case 8:
        return '_UnionPay';
      default:
        return '';
    }
  }
}
